import { getActiveModalElement, MODAL_LIVE_REGION_CLASS } from '../../tnew/ui/Modal';
import createAriaLiveElement from './createAriaLiveElement';

const LIVE_REGION_SELECTOR = `.${MODAL_LIVE_REGION_CLASS}`;

let $bodyEl;

export function setup() {
  if (!$bodyEl) {
    $bodyEl = createAriaLiveElement();
    document.body.appendChild($bodyEl);
  }
}

/**
 * @param {string} message
 */
export default function announce(message) {
  const $modal = getActiveModalElement();
  const $modalRegion = $modal ? $modal.querySelector(LIVE_REGION_SELECTOR) : null;

  if ($modalRegion) {
    $modalRegion.innerHTML = message;
    return;
  }

  if (!$bodyEl) {
    setup();
  }

  $bodyEl.innerHTML = message;
}
